import { Tooltip, TooltipTrigger } from '@backstage/ui';
import styles from './HistoryChecksTable.module.css';

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function dayBackground(
  noData: boolean,
  failing: number,
  severity: string,
): string {
  if (noData) return 'var(--zf-sc-neutral)';
  if (failing > 0) return `var(--zf-sc-sev-${severity})`;
  return 'var(--zf-sc-pass)';
}

function formatDate(date: string): string {
  const parts = date.split('-');
  const month = Number(parts[1]) - 1;
  const day = Number(parts[2]);
  return `${day} ${MONTHS[month] ?? ''}`;
}

interface DayItem {
  date: string;
  failing: number;
  inScope: number;
}

interface DailyBarProps {
  daily: DayItem[];
  severity: string;
}

export const DailyBar = ({ daily, severity }: DailyBarProps) => (
  <span role="img" aria-label="Daily failure bars" className={styles.dailyBar}>
    {daily.map(d => {
      const noData = d.inScope === 0;
      const ratio = noData ? 1 : d.failing / d.inScope;
      const bg = dayBackground(noData, d.failing, severity);
      const label = `${formatDate(d.date)}: ${d.failing} of ${
        d.inScope
      } failing`;

      return (
        <TooltipTrigger key={d.date} delay={0}>
          <button
            type="button"
            className={styles.dailyBarDay}
            aria-label={label}
          >
            <span
              className={styles.dailyBarFill}
              style={{ height: `${ratio * 100}%`, background: bg }}
            />
          </button>
          <Tooltip>{label}</Tooltip>
        </TooltipTrigger>
      );
    })}
  </span>
);
